/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound(registration) {
      console.log('New content is downloading.')

      // Verificar si registration.waiting no es nulo antes de enviar el mensaje.
      if (registration.waiting) {
        registration.waiting.postMessage({ action: 'skipWaiting' })
      }
    },
    updated(registration) {
      console.log('New content is available; please refresh.')

      // Verificar si registration.waiting no es nulo antes de enviar el mensaje.
      if (registration.waiting) {
        registration.waiting.postMessage({ action: 'skipWaiting' })

        // Escuchar mensajes del Service Worker
        navigator.serviceWorker.addEventListener('message', event => {
          if (event.data && event.data.action === 'skipWaiting') {
            // Forzar la activación del nuevo Service Worker
            console.log('Forzando la activación del nuevo Service Worker.')
            window.location.reload()
          }
        })
      }
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
